import Header from '@/components/header.vue'
import Bottom from '@/components/bottom.vue'
import cloud from '@/components/cloud.vue'
import noticeItem from '@/components/noticeItem.vue'
import coItem from '@/components/coItem.vue'
import newsItem from '@/components/newsItem.vue'
import top from '@/components/top.vue'
const components = [
  Header,
  noticeItem,
  coItem,
  newsItem,
  Bottom,
  cloud,
  top
];
const install = function(Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

export default install


// WEBPACK FOOTER //
// ./src/utils/globalComponents.js